import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="help-ticket-form"
export default class extends Controller {
  static targets = ["attachmentRow"]

  attachmentRowTargetConnected(element) {
    const removeBtn = element.querySelector(".remove-attachment-btn")
    if (removeBtn) {
      removeBtn.addEventListener("click", (e) => {
        e.preventDefault()
        element.remove()
      })
    }
  }
}
